// extracted by mini-css-extract-plugin
export default {"root":"SrvAddForm_root__JX9nY","service":"SrvAddForm_service__e2dOA","protocol":"SrvAddForm_protocol__p1Mn2","port":"SrvAddForm_port__2lQ7Z"};